export default __webpack_public_path__ + "static/media/logo-landscape.d512c18a.svg";